import { render, staticRenderFns } from "./AffiliatedHosp.vue?vue&type=template&id=2437005e&scoped=true"
import script from "./AffiliatedHosp.vue?vue&type=script&lang=js"
export * from "./AffiliatedHosp.vue?vue&type=script&lang=js"
import style0 from "./AffiliatedHosp.vue?vue&type=style&index=0&id=2437005e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437005e",
  null
  
)

export default component.exports